import React, { useState,useContext } from 'react';
import './Navbar.css';
import blogic from './../Images/blogic.jpeg'; // Adjust the path as necessary
import Avatar from 'react-avatar';
import { AuthContext } from '../ContextApi/ContextApi';
const Navbar = () => {
  const { firstName, lastName } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  return (
    <nav className="mobile-navbar">
      <div className="navbar-content">
        {/* Logo and Toggle Button */}
        <div className="navbar-header">
          <button 
            className="menu-toggle" 
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <div className={`hamburger ${menuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
          
          <a href="#" className="navbar-logo">
            <img src={blogic} alt="App Logo" />
          </a>
        </div>

        {/* Profile Dropdown Trigger */}
        <div className="profile-section">
          
           <div className="avatar-wrapper" onClick={() => setProfileOpen(!profileOpen)}>
        <Avatar name={`${firstName} ${lastName}`} size="40" round={true} />
      </div>

          {/* Profile Dropdown */}
          {profileOpen && (
            <div className="profile-dropdown">
              <a href="/Profile" className="dropdown-item">
                <i className="icon-user"></i> Profile
              </a>
              
              <a href="/" className="dropdown-item">
                <i className="icon-logout"></i> Logout
              </a>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="mobile-menu">
          <a href="/Home" className="menu-item">Home</a>
          <a href="/collect" className="menu-item">Collect</a>
          <a href="/report" className="menu-item">Report</a>
          
        </div>
      )}
    </nav>
  );
};

export default Navbar;